import { useEffect } from 'react';
import { createFileRoute } from '@tanstack/react-router';

function AdminRedirect() {
  useEffect(() => {
    window.location.href = window.location.origin + '/admin/tokens';
  }, []);
  return null;
}

export const Route = createFileRoute('/admin/')({
  component: AdminRedirect,
});
